<p>
  Migrant & Seasonal Head Start (MSHS) is a federally funded program which provides comprehensive Head Start services,
  including child development/school readiness, social and health (including nutrition, oral health and mental wellness)
  services to low income families working in agriculture, or families who migrate for the purpose of working in
  agriculture.
</p>
<p>Criteria for Enrollment to MSHS programs:</p>
<ul class="padding-left-4">
  <li>Income below federal poverty guidelines</li>
  <li>Birth to compulsory school Age</li>
  <li>
    With respect to services for migrant farmworkers, families must be engaged in agricultural labor and changed their
    residence from one geographic location to another in the preceding 2-year period
  </li>
  <li>
    With respect to services for seasonal farmworkers, families must be engaged primarily in seasonal agricultural labor
    and who have not changed their residence to another geographic location in the preceding 2-year period
  </li>
  <li>51% of income from agriculture within the last 12 months-families must meet this requirement each year</li>
</ul>
<p>NOTE: The data used for this tool is current as of {{ refreshDate }} in the HRSA Data Warehouse</p>
<p>
  HELP:
  <a href="https://www.hrsa.gov/about/contact/ehbhelp.aspx" target="_blank" title="HRSA Contact Center"
    >HRSA Contact Center</a
  >
  is available at 877-464-4772, 8 a.m. to 8 p.m. ET, weekdays (except federal holidays).
</p>
